import styled from "styled-components";

export const Flex = styled.div`
  display: flex;
`;

export const Stack = styled(Flex)`
  flex-direction: column;
`;
